/**
 * lc-subscribe.js — controller for the /pages/subscribe form (.ps-form).
 *
 * The Klaviyo subscription itself is delegated to window.lcKlaviyoSubscribe
 * (assets/lc-klaviyo-subscribe.js), which fires the GA4 generate_lead bridge on
 * success. This module owns only the page-specific feedback UI. Consolidated
 * onto the shared core per LOS7-1324; the subscribe page targets its own list
 * (klaviyo_journal_list_id), carried on the form's data-list-id.
 */
(function () {
  'use strict';

  var form = document.getElementById('lc-subscribe-form');
  if (!form) return;

  var emailInput = form.querySelector('input[name="email"]');
  var feedback = form.querySelector('.ps-form__feedback');
  var companyId = form.dataset.companyId;
  var listId = form.dataset.listId;

  if (!companyId || !listId) {
    showFeedback('error', 'Subscribe form not configured. Theme settings → Klaviyo.');
    return;
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (form.classList.contains('is-loading')) return; // in-flight guard
    var email = (emailInput.value || '').trim();

    if (!isValidEmail(email)) {
      showFeedback('error', 'Please enter a valid email address.');
      emailInput.focus();
      return;
    }

    form.classList.add('is-loading');
    showFeedback('', '');

    window
      .lcKlaviyoSubscribe({
        email: email,
        companyId: companyId,
        listId: listId,
        source: 'Journal Subscribe Page',
        customSource: 'Lost Collective journal subscribe page',
      })
      .then(function () {
        form.classList.remove('is-loading');
        form.reset();
        showFeedback('success', 'Subscribed. Check your inbox for confirmation.');
      })
      .catch(function () {
        form.classList.remove('is-loading');
        showFeedback('error', 'Something went wrong. Try again, or email hello@lostcollective.com.');
      });
  });

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showFeedback(state, message) {
    feedback.textContent = message;
    feedback.classList.remove('is-success', 'is-error');
    if (state === 'success') feedback.classList.add('is-success');
    if (state === 'error') feedback.classList.add('is-error');
  }
})();
